import { findExistingAddressHoursIndex } from './findExistingAddressHoursIndex';
import { mergeDepartmentNames } from './mergeDepartmentNames';
import { mergePhones } from './mergePhone.js';
import { buildAddress } from './buildAddress';

/**
 * Attempts to merge a department with an existing address entry.
 * Combines the functionality of finding a matching address and merging phone data.
 *
 * @param {WidgetLocation[]} addresses - Array of existing location addresses
 * @param {ADDDepartment} department - The department to merge
 * @param {String} defaultPhone - Default phone number for fallback
 * @returns {{success: boolean, index?: number}} Returns {success: true, index} if merged, {success: false} if not
 */
export const mergeDepartmentInAddress = (
	addresses,
	department,
	defaultPhone
) => {
	const fullAddress = buildAddress(department);
	const { hours, label, type } = department;
	// Step 1: Find if there's an existing address with matching hours
	const matchingIndex = findExistingAddressHoursIndex(
		addresses,
		fullAddress,
		hours
	);

	// Step 2: If no match found, return early
	if (matchingIndex === -1) {
		return {
			success: false,
			shouldCreateNew: true
		};
	}

	// Step 3: Merge department names
	const targetAddress = addresses[matchingIndex];
	const currentDeptName = targetAddress.departmentName;
	const newDeptLabel = label || type || 'Department';
	const mergedName = mergeDepartmentNames(currentDeptName, newDeptLabel);

	// Update department name
	// eslint-disable-next-line no-param-reassign
	targetAddress.departmentName = mergedName;

	// Step 4: Merge phone if not duplicate
	const phoneAdded = mergePhones(targetAddress, department, defaultPhone);

	return {
		success: true,
		index: matchingIndex,
		phoneAdded
	};
};
